<template>
    <div>
        <label
            v-if="!isImportStyle || (isImportStyle && valueFiles?.length === 0)"
            :for="`upload-common-${id}`"
            :class="`btn ${$props.classLabel}`"
            class="mb-0"
            :style="{ cursor: disabled ? 'not-allowed' : 'pointer' }"
            :disabled="disabled"
            ><span><i class="fa fa-upload" aria-hidden="true"></i></span> {{ $props.title || $t('btn.uploadFile') }}</label
        >
        <input :disabled="disabled" type="file" :id="`upload-common-${id}`" ref="fileInput" hidden @change="handleFile" />
        <slot name="warning"></slot>
        <template v-if="(configUpload.isPreview || isImportStyle) && valueFiles?.length > 0">
            <template v-for="(item, index) in valueFiles">
                <div v-if="!isImportStyle" :key="`normal-${index}`" class="mb-2">
                    <div class="d-flex align-items-baseline">
                        <template v-if="item?.extension">
                            <i v-if="IMAGE_EXTENSIONS.includes(item?.extension.toLowerCase())" class="ri-file-image-line"></i>
                            <i v-else class="ri-file-line"></i>
                        </template>
                        <div class="preview_file" v-b-tooltip.hover :title="item?.origin_name || ''">
                            <a v-if="item?.path" target="_blank" :href="item?.path" @click.prevent="handleDownFile(item?.path, item?.origin_name)"
                                >{{ item?.origin_name ?? '' }}
                            </a>
                            <span v-else>{{ item?.origin_name ?? '' }}</span>
                        </div>
                        <button class="btn btn-sm btn-danger btn_delete_file" type="button" @click="onDeleteFile(index)">
                            <i class="ri-close-line"></i>
                        </button>
                    </div>
                    <div v-if="typeUpload === 'image' && item?.path" class="preview_img">
                        <b-img thumbnail fluid :src="item?.path" :alt="item.origin_name"></b-img>
                    </div>
                </div>

                <div v-else :key="`import-${index}`" class="import-style-container p-3 border rounded">
                    <div class="file-card d-flex align-items-center justify-content-between p-2 mb-3 bg-light border rounded">
                        <div class="d-flex align-items-center flex-grow-1 overflow-hidden mr-2">
                            <i class="ri-file-text-line mr-2" style="font-size: 32px; color: #999"></i>
                            <div class="text-truncate">
                                <span class="font-weight-bold text-dark" v-b-tooltip.hover :title="item?.origin_name || ''">{{
                                    item?.origin_name ?? ''
                                }}</span>
                                <div class="text-muted small">{{ item?.fileSize || 0 }} KB</div>
                            </div>
                        </div>
                        <button
                            class="btn btn-sm btn-danger delete-btn d-flex align-items-center"
                            style="min-width: 60px"
                            type="button"
                            @click="onDeleteFile(index)"
                        >
                            <i class="ri-delete-bin-line mr-1"></i>
                            <span>削除</span>
                        </button>
                    </div>
                    <div class="text-center">
                        <label
                            :for="`upload-common-${id}`"
                            class="mb-0 btn btn-info"
                            :style="{ cursor: disabled ? 'not-allowed' : 'pointer' }"
                            :disabled="disabled"
                        >
                            <i class="ri-restart-line mr-2"></i>
                            <span>再インポート</span>
                        </label>
                    </div>
                </div>
            </template>
        </template>
    </div>
</template>

<script>
import { campaignMethods } from '@/state/helpers';
import { showMessage } from '@/utils/messages';
import { validateFileFormat } from '@/utils/handlers';
import { convertKBtoMB, handleDownFile, IMAGE_EXTENSIONS } from '@/utils/format';

export default {
    props: {
        fileValues: {
            type: [Array, Object, String],
            default: () => []
        },
        id: {
            type: String,
            default: ''
        },
        title: {
            type: String,
            default: ''
        },
        classLabel: {
            type: String,
            default: 'btn-info'
        },
        disabled: {
            type: Boolean,
            default: false
        },
        typeUpload: {
            type: String,
            default: 'file'
        },
        processUpload: {
            type: Boolean,
            default: false
        },
        config: {
            type: Object,
            default: () => {
                {
                    return {
                        isUpDemo: false,
                        allowedSize: 1024,
                        allowedExtension: []
                    };
                }
            }
        },
        isImportStyle: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            fileInfo: {
                originName: '',
                extension: '',
                fileSize: 0
            },
            configUpload: {
                ...this.config,
                multiple: false,
                isPreview: true
            },
            valueFiles: this.fileValues,
            IMAGE_EXTENSIONS
        };
    },
    computed: {
        isMultiple() {
            return this.configUpload?.multiple;
        }
    },
    methods: {
        ...campaignMethods,
        handleDownFile,

        onHandleGetValues(dataValues) {
            if (this.isMultiple) {
                this.valueFiles.push({ ...dataValues });
            } else {
                this.valueFiles = this.typeUpload === 'readFile' ? dataValues : [{ ...dataValues }];
            }
        },

        handleFile() {
            const fileInput = this.$refs.fileInput;
            if (this.typeUpload == 'file') {
                this.displayFileInfoFile(fileInput);
            } else if (this.typeUpload == 'image') {
                this.displayFileInfoImage(fileInput);
            } else if (this.typeUpload == 'readFile') {
                this.onHandleReadFile(fileInput);
            } else if (this.typeUpload == 'import') {
                this.onHandleImportFile(fileInput);
            }
        },

        onHandleImportFile(fileInput) {
            const getFile = fileInput.files[0];
            if (!getFile) return;
            this.fileInfo.extension = getFile.name.split('.').pop();
            this.fileInfo.type = getFile.type.split('/').pop();
            this.fileInfo.fileSize = (getFile.size / 1024).toFixed(2);
            this.$refs.fileInput.value = '';
            if (!validateFileFormat(getFile, this.configUpload, this.$bvToast)) {
                return;
            }
            if (Number(this.fileInfo.fileSize) >= Number(this.configUpload.allowedSize) && !this.configUpload?.maxSize) {
                showMessage(8080, this.$bvToast, this.$t('uploadFile.maxSize1MB'));
                return;
            }
            this.onHandleGetValues({
                ...this.fileInfo,
                origin_name: getFile.name
            });
            this.$emit('importFile', getFile);
        },

        async onHandleReadFile(fileInput) {
            const getFile = fileInput.files[0];
            if (!getFile) return;
            const formData = new FormData();
            formData.append('file', getFile);
            this.fileInfo.extension = getFile.name.split('.').pop();
            this.fileInfo.type = getFile.type.split('/').pop();
            this.fileInfo.fileSize = (getFile.size / 1024).toFixed(2);
            this.$refs.fileInput.value = '';
            if (!validateFileFormat(getFile, this.configUpload, this.$bvToast)) {
                return;
            }
            if (Number(this.fileInfo.fileSize) >= Number(this.configUpload.allowedSize) && !this.configUpload?.maxSize) {
                showMessage(8080, this.$bvToast, this.$t('uploadFile.maxSize1MB'));
                return;
            }
            this.$emit('update:processUpload', true);
            try {
                const dataRead = await this.readFileUpload(formData);
                if (dataRead?.code == 200) {
                    this.onHandleGetValues(dataRead.data);
                    this.$emit('dataFile', dataRead.data);
                }
            } catch (error) {
                console.log('error', error);
            } finally {
                this.$emit('update:processUpload', false);
            }
        },

        displayFileInfoFile(receivedFile) {
            if (receivedFile.files.length > 0) {
                const file = receivedFile.files[0];
                this.fileInfo.originName = file.name;
                this.fileInfo.extension = file.name.split('.').pop(); // Lấy phần mở rộng của tệp
                this.fileInfo.type = file.type.split('/').pop(); // Lấy phần mở rộng của tệp
                this.fileInfo.fileSize = (file.size / 1024).toFixed(2); // Chuyển đổi size sang KB và làm tròn đến 2 chữ số thập phân
                this.$refs.fileInput.value = '';
                if (!validateFileFormat(file, this.configUpload, this.$bvToast)) {
                    return;
                }
                if (Number(this.fileInfo.fileSize) >= Number(this.configUpload.allowedSize) && !this.configUpload?.maxSize) {
                    showMessage(8080, this.$bvToast, this.$t('uploadFile.maxSize1MB'));
                    return;
                }
                if (this.configUpload?.maxSize && Number(this.fileInfo.fileSize) >= Number(this.configUpload?.maxSize)) {
                    if (!this.id.includes('UploadFileForm')) {
                        if (convertKBtoMB(this.configUpload?.maxSize) >= 1) {
                            showMessage(
                                8080,
                                this.$bvToast,
                                this.$t('uploadFile.maxSizeCustom', {
                                    size: convertKBtoMB(this.configUpload?.maxSize)
                                })
                            );
                        } else {
                            showMessage(8080, this.$bvToast, `ファイルサイズは${this.configUpload?.maxSize}KBキロバイト以内にしてください。`);
                        }
                        return;
                    }
                }

                if (this.configUpload?.isUpDemo) {
                    const objDemo = {
                        ...this.fileInfo,
                        origin_name: this.fileInfo.originName
                    };
                    this.onHandleGetValues(objDemo);
                    this.$emit('dataFile', objDemo);
                    return;
                }

                let query = `origin_name=${this.fileInfo.originName}&extension=${this.fileInfo.extension}&file_size=${parseInt(this.fileInfo.fileSize)}&type=${this.fileInfo.type}`;
                this.$emit('update:processUpload', true);
                this.uploadFile(query).then((data) => {
                    if (data.code == 200) {
                        data.data.origin_name = this.fileInfo.originName;
                        data.data.extension = this.fileInfo.extension;
                        data.data.fileSize = this.fileInfo.fileSize;
                        this.onHandleGetValues(data.data);
                        this.$emit('dataFile', data.data);
                        receivedFile.value = '';
                        const formData = new FormData();
                        formData.append('file', file);
                        var requestOptions = {
                            method: 'PUT',
                            body: file
                        };
                        fetch(data.data.url, requestOptions)
                            .then((response) => response.text())
                            .then()
                            .catch((error) => console.log('error', error));
                    }
                    this.$emit('update:processUpload', false);
                });
            }
        },

        displayFileInfoImage(receivedFile) {
            if (!receivedFile.files.length) return;
            const file = receivedFile.files[0];
            this.fileInfo.originName = file.name;
            this.fileInfo.extension = file.name.split('.').pop(); // Lấy phần mở rộng của tệp
            this.fileInfo.type = file.type; // Lấy phần mở rộng của tệp
            this.fileInfo.fileSize = (file.size / 1024).toFixed(2); // Chuyển đổi size sang KB và làm tròn đến 2 chữ số thập phân
            this.$refs.fileInput.value = '';
            if (!validateFileFormat(file, this.configUpload, this.$bvToast)) {
                return;
            }
            if (Number(this.fileInfo.fileSize) >= Number(this.configUpload.allowedSize) && !this.configUpload?.maxSize) {
                showMessage(8080, this.$bvToast, this.$t('uploadFile.maxSize1MB'));
                return;
            }

            if (Number(this.fileInfo.fileSize) >= Number(this.configUpload?.maxSize)) {
                showMessage(
                    8080,
                    this.$bvToast,
                    this.$t('uploadFile.maxSizeCustom', {
                        size: convertKBtoMB(this.configUpload?.maxSize)
                    })
                );
                return;
            }
            let query = `origin_name=${this.fileInfo.originName}&extension=${
                this.fileInfo.extension
            }&file_size=${parseInt(this.fileInfo.fileSize)}&type=${this.fileInfo.type}`;
            this.$emit('update:processUpload', true);
            this.uploadFile(query).then((data) => {
                if (data.code == 200) {
                    data.data.origin_name = this.fileInfo.originName;
                    data.data.extension = this.fileInfo.extension;
                    data.data.fileSize = this.fileInfo.fileSize;
                    this.onHandleGetValues(data.data);
                    this.$emit('dataFile', data.data);
                    receivedFile.value = '';
                    const formData = new FormData();
                    formData.append('file', file);
                    var requestOptions = {
                        method: 'PUT',
                        body: file
                    };
                    fetch(data.data.url, requestOptions)
                        .then((response) => response.text())
                        .then()
                        .catch((error) => console.log('error', error));
                }
                this.$emit('update:processUpload', false);
            });
        },

        onDeleteFile(idx) {
            this.valueFiles.splice(idx, 1);
            this.$emit('removeFile');
        }
    },

    watch: {
        config: {
            handler: function (newConfig) {
                this.configUpload = {
                    ...this.configUpload,
                    ...newConfig
                };
            },
            immediate: true,
            deep: true
        },

        fileValues: {
            handler: function (newValue) {
                if (newValue && Array.isArray(newValue)) {
                    this.valueFiles = newValue;
                } else {
                    this.valueFiles = newValue ? [newValue] : [];
                }
            },
            immediate: true
        },

        valueFiles: {
            handler: function (newValue) {
                this.$emit('update:fileValues', this.isMultiple ? newValue : newValue?.[0] || null);
            },
            immediate: true,
            deep: true
        }
    }
};
</script>

<style lang="scss" scoped>
label {
    display: inline-block;
    color: white;
    cursor: pointer;
}
.preview_file {
    min-width: 80px;
    padding-right: 10px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: pre;
}

.btn_delete_file {
    width: 18px;
    height: 18px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.preview_img {
    width: 200px;
    height: 200px;
    img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        object-position: center;
        border-radius: 10px;
    }
}

.import-style-container {
    background-color: #fff;
    width: 600px;

    .success-msg {
        h5 {
            letter-spacing: 1px;
        }
    }

    .file-card {
        background-color: #f8f9fa;
        border: 1px solid #e9ecef !important;

        .delete-btn {
            background-color: #f15d5d;
            border-color: #f15d5d;
            padding: 4px 6px;
            font-size: 12px;

            &:hover {
                background-color: #dc3545;
                border-color: #dc3545;
            }
        }
    }

    .btn-primary {
        background-color: #5d9cec;
        border-color: #5d9cec;

        &:hover {
            background-color: #4a89dc;
            border-color: #4a89dc;
        }
    }
}
</style>
